import router from '@/router';
import { userClient } from '@/js/helpers/backend-clients';
import {
  clearLastDisplayedMessage,
  displayAxiosError,
  displayErrorMessage,
  displayInfoMessage,
  hideLoadingOverlay,
  showLoadingOverlay,
} from '@/js/helpers/utils';
import store from '@/store';

const defaultState = () => {
  let userdata = window.sessionStorage.getItem('userdata');
  let userdataParsed = userdata ? JSON.parse(userdata) : undefined;
  return {
    username: userdataParsed ? userdataParsed.username : undefined,
    emailVerified: userdataParsed ? userdataParsed.emailVerified : false,
  };
};

const state = defaultState();

const mutations = {
  UPDATE_USERNAME(state, name) {
    state.username = name;
  },
  UPDATE_EMAIL_VERIFIED(state, verified) {
    state.emailVerified = verified;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
  login({ dispatch, commit }, userdata) {
    clearLastDisplayedMessage();
    showLoadingOverlay();
    userClient
      .login(userdata.username, userdata.password)
      .then(({ data }) => {
        dispatch('address/reset', null, { root: true });
        window.sessionStorage.setItem(
          'userdata',
          JSON.stringify({
            name: data.username,
            emailVerified: data.emailVerified,
          }),
        );
        router.push('/gutachtenauswahl').then();
      })
      .catch(error => {
        displayAxiosError(error);
      })
      .finally(() => hideLoadingOverlay());
  },
  logout({ dispatch }) {
    showLoadingOverlay();
    dispatch('resetModules', undefined, { root: true });
    userClient.logout().then(() => {
      router.push('/login').finally(() => {
        window.sessionStorage.removeItem('userdata');
        hideLoadingOverlay();
      });
    });
  },
  passwortVergessen({ dispatch, commit }, emailAdresse) {
    clearLastDisplayedMessage();
    showLoadingOverlay();
    userClient
      .passwortVergessen(emailAdresse)
      .then(() => {
        displayInfoMessage(
          'Falls das Konto bei uns registriert und aktiv ist, erhalten Sie einen Link per E-Mail, mit dem das Passwort zurückgesetzt werden kann.',
        );
        router.push('/login').then();
      })
      .catch(error => {
        displayAxiosError(error);
      })
      .finally(() => {
        hideLoadingOverlay();
      });
  },
  passwortZuruecksetzen({ dispatch }, passwordBundle) {
    if (passwordBundle.password !== passwordBundle.passwordBestaetigung) {
      displayErrorMessage('Die eingegebenen Passwörter stimmen nicht überein');
    } else {
      showLoadingOverlay();
      userClient
        .passwortZuruecksetzen(
          passwordBundle.password,
          passwordBundle.passwordBestaetigung,
          passwordBundle.autorisierungsCode,
        )
        .then(() => {
          displayInfoMessage('Das Passwort wurde erfolgreich geändert');
          router.push('/login').then();
        })
        .catch(error => {
          displayAxiosError(error);
        })
        .finally(() => {
          hideLoadingOverlay();
        });
    }
  },
  sendeNeuesPasswort({ dispatch }, passwordBundle) {
    if (passwordBundle.passwortNeu !== passwordBundle.passwortNeuBestaetigung) {
      displayErrorMessage('Die eingegebenen Passwörter stimmen nicht überein');
    } else {
      showLoadingOverlay();
      userClient
        .passwortAendern(
          passwordBundle.emailAdresse,
          passwordBundle.passwortAlt,
          passwordBundle.passwortNeu,
          passwordBundle.passwortNeuBestaetigung,
        )
        .then(() => {
          displayInfoMessage('Das Passwort wurde erfolgreich geändert');
          router.push('map').then();
        })
        .catch(error => {
          displayAxiosError(error);
        })
        .finally(() => {
          hideLoadingOverlay();
        });
    }
  },
  setUsername({ commit }, username) {
    commit('UPDATE_USERNAME', username);
  },
  setEmailVerified({ commit }, verified) {
    commit('UPDATE_EMAIL_VERIFIED', verified);
  },
  verifyEmail({ commit }, token) {
    showLoadingOverlay();
    userClient
      .verifiziereEmail(token)
      .then(({ data }) => {
        window.sessionStorage.setItem(
          'userdata',
          JSON.stringify({
            name: data.username,
            emailVerified: data.emailVerified,
          }),
        );
        store.dispatch('user/reset').then(() => {
          displayInfoMessage('Die E-Mail-Adresse wurde erfolgreich verifiziert.');
          router.push('/gutachtenauswahl').then();
        });
      })
      .catch(() => {
        displayErrorMessage('Verifizierung ungültig');
        router.push('/login').then();
      })
      .finally(() => {
        hideLoadingOverlay();
      });
  },
  reset({ commit }) {
    commit('RESET_STATE');
  },
};
const getters = {
  error: () => state.error,
  username: () => state.username,
  emailVerified: () => state.emailVerified,
};

const userModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default userModule;
